import type {GuidedV2ResultQuickLinkUiProvider, GuidedV2Schema, QuickLinkHandlers} from '../guided2/models/ui';
import {predefinedConfigs} from './services/guided-v2-service/predefined-config';


type GuidedStrategyObserver = (service:GuidedV2StrategyService)=>void;
type RemoveListenerCallback = ()=>void;

export abstract class GuidedV2StrategyService {
  protected _details: GuidedV2StrategyParams;

  public loadPredefined(name: string){
      if(name in predefinedConfigs){
        this.details = {
          ...this.details,
          ...predefinedConfigs[name]
        };
      }
  }

  get details(): GuidedV2StrategyParams {
      return this._details;
  }
  set details(value: GuidedV2StrategyParams) {
      this._details = value;
      this.triggerCallbacks();
  }


  protected detailsChangedCallbacks: Array<GuidedStrategyObserver> = [];
  protected triggerCallbacks() {
      for (const callback of this.detailsChangedCallbacks) {
        callback(this);
      }
  }
  public onStrategyDetailsChange(callback: GuidedStrategyObserver): RemoveListenerCallback {
      this.detailsChangedCallbacks.push(callback);
      return () => {
          this.detailsChangedCallbacks = this.detailsChangedCallbacks.filter(cb => cb !== callback);
      };
  }

  abstract getSchema(): GuidedV2Schema;

  abstract getQuickLinkTemplateMapper(quickLinkHandlers:QuickLinkHandlers): GuidedV2ResultQuickLinkUiProvider;
}

export interface GuidedV2StrategyData {
  strategyType: string,
  params: Partial<GuidedV2StrategyParams>,
}


export interface GuidedV2StrategyParams {
  /**
   * The amount of time to wait after the user stops typing before making a suggestion.
   * If the user keeps typing - we don't send another call to the server.
   */
  debounceTimeMs?: number;

  backendTimeoutMs?: number;

  useBackdrop: boolean;

  schema: GuidedV2Schema;
  /**
   * Enable the background scroll when the guided is active and the backdrop is visible
   */
  enableBackgroundScroll: boolean;

  quickLinkTemplateMapperType?: string;
  /**
   * The threshold for the quicklink tag or attribute similarity
   * with search term to be highlighted
   */
  badgeHighlightThreshold: number;

  /**
   * The threshold for the quicklink title or description similarity
   * with search term to be highlighted
   */
  markupHighlightThreshold: number;
  country?: string;
  language?: string;
}

export const GuidedV2Defaults: GuidedV2StrategyParams = {
  debounceTimeMs: 500,
  backendTimeoutMs: 7500,
  useBackdrop: true,
  enableBackgroundScroll: false, //GS v1 has false default
  quickLinkTemplateMapperType: 'default',
  badgeHighlightThreshold: 0.04,
  markupHighlightThreshold: 0.02,
  schema: {
    minLength: 3,
    sections: [],
  }
};
